// latLonToVec3.ts - a body-fixed point from latitude, longitude and radius.
//
// Split out of src/atlas.ts so both the composition root and surfaceRadius.ts
// can import it without either value-importing the other: src/atlas/README.md
// forbids a value import back into src/atlas.ts from a file here.
//
// The axis convention this fixes - x/z from cos(lat), y from sin(lat), -sin(lon)
// on z - is what globeMaterial.ts, tileMesh.ts, hexOverlay.ts and
// plotGeometry.ts all cite when they describe a body-fixed frame.

import * as THREE from 'three';

export function latLonToVec3(latDeg: number, lonDeg: number, radius: number): THREE.Vector3 {
  const lat = THREE.MathUtils.degToRad(latDeg);
  const lon = THREE.MathUtils.degToRad(lonDeg);
  const x = radius * Math.cos(lat) * Math.cos(lon);
  const y = radius * Math.sin(lat);
  const z = -radius * Math.cos(lat) * Math.sin(lon);
  return new THREE.Vector3(x, y, z);
}
